import axios from "axios";
import { API_CONFIG } from '../../config/api';

export const MISSION_API = {
    getMissions: (token: string, customer_pk: string, user_pk: number) => axios.get(
        `${API_CONFIG.HOSTNAME}${API_CONFIG.API_PREFIX}${API_CONFIG.API_VERSION}/customer/${customer_pk}/user/${user_pk}/mission/`,
        { headers: { "Content-type": "application/json", Authorization: "Token " + token } }
    ),
};
